/**
 * AnimatedNumber — counts from 0 → target with an ease-out curve.
 * Pure CSS-free, ~24 frames, RAF-driven, deterministic.
 */
import { useEffect, useRef, useState } from 'react';

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

export default function AnimatedNumber({ value = 0, duration = 1200, format = (v) => v, className = '', testid }) {
  const [n, setN] = useState(0);
  const startRef = useRef(null);
  const fromRef = useRef(0);
  const toRef = useRef(value);
  const rafRef = useRef(null);

  useEffect(() => {
    fromRef.current = n;
    toRef.current = value;
    startRef.current = null;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const t = Math.min(1, (ts - startRef.current) / duration);
      const v = fromRef.current + (toRef.current - fromRef.current) * easeOut(t);
      setN(v);
      if (t < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [value, duration]);

  return <span className={className} data-testid={testid}>{format(Math.round(n))}</span>;
}
